<template lang="pug">
v-navigation-drawer(
  :class="['support overflow-hidden', $vuetify.breakpoint.mobile ?'support-full':'']"
  :value="getshowFaqSidebar"
  absolute
  temporary
  right
  @input="setFaqStatus"
  v-click-outside="onClickOutside")
  div(class="support_header")
    span(class="support_header__text") {{ $t('label.faq.title') }}
    v-btn(id="support_header_close" icon @click="setFaqStatus(false)")
      v-icon(@click="clearSearch" class="support_header-close") $close
  div(class="support_search")
    v-text-field(
      class="support_search__input"
      solo
      style="color:lightgrey"
      placeholder="Axtarış"
      @input="faqSearch"
      v-model="suportSearchValue"
      prepend-inner-icon='$search')
      template(v-slot:append)
        v-icon(class="support_header-close" @click="clearSearch" v-if="suportSearchValue") $close
  div(class="support_questions")
    span(class="support_questions__header d-block mb-5 mt-8") Tez-tez verilən suallar
    v-card(class="support_questions__content rounded-lg mx-auto" outlined)
      v-row(justify='center' v-if="filteredItems.length>0").ma-0
        v-expansion-panels(class="accordion" accordion)
          v-expansion-panel(v-for='(item,i) in filteredItems' :key='i').mb-5
            v-expansion-panel-header(class="accordion-header px-0 py-0" ) {{item.title}}
            v-expansion-panel-content(class="accordion-content" ).mt-2
              p {{item.description}}
              br
              p {{item.description2}}
            v-divider
      .support_questions__content__empty(v-else)
        v-icon $filter-empty
        p {{ $t('misc.support.search.empty') }}
    .support_contacts
      .support_contacts__network
        h4 {{ $t('label.faq.contact.title') }}
        .support_contacts__network-social
          v-btn(id="support_whatsapp" icon href="https://wa.me/+994505252030")
            v-icon.support_contacts__network-social-icon $whatsapp
          v-btn(id="support_messenger" icon href="https://m.me/108642704997781")
            v-icon.support_contacts__network-social-icon $messenger
      ul.support_contacts__network-info
        li(v-for="(item, i) in connects" :key="i")
          a(:href="item.href" target="_blank")
            v-icon(size="20" v-text="item.icon")
            span {{item.text}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AppFaq',
  data() {
    return {
      suportSearchValue: '',
      items: [
        {
          title: '“MPAY” xidmətlərindən necə yararlana bilərəm?',
          description:
            '“MPAY” tətbiqini “Google Play” və ya “App Store” mobil telefonunuza yükləyərək və birbaşa veb-saytdan nömrə ilə qeydiyyatdan keçin. Telefonunuza göndəriləcək birdəfəlik şifrəni (OTP) daxil edin. Gələcəkdə “MPAY”ə daxil olmaq üçün özünüzə şifrə təyin edin. Hazırdır! Artıq ödənişləri və köçürmələri rahat edə bilərsiniz.',
        },
        {
          title: 'MPAY balansını necə artıra bilərəm?',
          description:
            '“MPAY” elektron cüzdan balansını bank kartları və ya MPAY/eManat terminalları vasitəsilə artıra bilərsiniz. “MPAY” terminallarda “E-pulqabı” kateqoriyasında yerləşir.',
        },
        {
          title: 'Balansımı artıran zaman komissiya tutulurmu?',
          description:
            '“MPAY” tərəfindən balans artırılma zamanı heç bir komissiya tətbiq olunmur. Bank kartları ilə ödəmə zamanı isə sizin bankınız tərəfindən kartınıza komissiya tətbiq oluna bilər.',
        },
        {
          title: 'NFC ödənişim NFC kart balansına köçmədikdə nə edə bilərəm?',
          description:
            'Uğurlu ödəniş etmisiniz, lakin kommunal kartı balansında məbləğ əks olunmursa, bərpa etmə funksiyası sınayın. Bərpa eynilə ödəniş kimidir: xidməti seçin, kartı telefona yaxınlaşdırın, ekranda əks olunacaq “Bərpa olunmalı ödəniş” düyməsinə toxunun və prosesi davam etdirin.',
        },
        {
          title: 'Azəriqaz, Azərsu NFC kartımın balansını necə artıra bilərəm?',
          description:
            '“Azəriqaz”, “Azərsu NFC” kartlarının balansını artırmaq üçün ilk öncə tətbiqdə kommunal kateqoriyasından uyğun xidməti seçin. Daha sonra kartı telefona yaxınlaşdırıb, bir neçə saniyə oxunmasını gözləyin. Smartfon kart məlumatlarını oxuduqdan sonra uyğun ödəniş mənbəyini seçib davam edin.',
          description2:
            'Qeyd edək ki, ödəniş etmək üçün smartfonunuz NFC dəstəkləməlidir. Smartfonunuz NFC dəstəkləyirsə, parametlərdən NFC funksiyasını aktivləşdirə bilərsiniz.',
        },
        {
          title: 'Ödəniş və xidmətlərdə çətinliklə qarşılaşdıqda nə edə bilərəm?',
          description:
            'Ödəniş və xidmətlərdə çətinliklə qarşılaşdıqda aşağıdakı əlaqə vasitələri ilə müraciət edə bilərsiniz:',
        },
      ],
      filteredItems: [],
    };
  },
  computed: {
    ...mapGetters('Ui', ['getshowFaqSidebar']),
    connects() {
      return [
        {
          icon: '$phone',
          text: '012 525 20 30',
          href: 'tel:+994125252030',
        },
        {
          icon: '$mail',
          text: 'contact@mpay.az',
          href: 'mailto:contact@mpay.az',
        },
        {
          icon: '$location',
          text: this.$t('label.faq.address'),
          href: 'https://www.google.com/maps/place/eManat/@40.4073957,49.8606473,17z/data=!4m6!3m5!1s0x40307d50ecc116f1:0x8c057bf1a686c4f9!8m2!3d40.4073916!4d49.8628413!16s%2Fg%2F11c206pcx3?hl=az',
        },
      ];
    },
  },
  mounted() {
    this.filteredItems = this.items;
  },
  methods: {
    ...mapActions('Ui', ['setFaqStatus']),
    faqSearch() {
      this.filteredItems = this.items.filter((item) => item.title.toLowerCase().includes(this.suportSearchValue.toLowerCase()) || item.description.toLowerCase().includes(this.suportSearchValue.toLowerCase()));
    },
    clearSearch() {
      if (this.suportSearchValue.length > 0) this.suportSearchValue = '';
      this.faqSearch();
    },
    onClickOutside() {
      this.suportSearchValue = '';
    },
  },
};
</script>
<style lang="scss">
.support.support-full{
  width: 100% !important;
}
.support {
  position: fixed;
  width: 32% !important;
  padding: 32px;
  .v-navigation-drawer__content{
    &::-webkit-scrollbar{
      width: 0;
    }
    .v-list-item__title{
      color: #262626;
    }
  }
  &_header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    height: auto;
    &__text {
      color: #262626;
      font-family: 'Poppins', 'Montserrat', sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
    }
    &-close {
      width: 12px !important;
      height: 12px !important;
    }
  }
  &_search {
    height: 43px;
    // margin-bottom: 16px;
    .v-icon__component {
      width: 15px;
      height: 15px;
    }
    .v-text-field__slot {
      margin-left: 7px;
    }
    .v-input__slot {
      background: #ffffff;
      border: 1px solid #e0e1e4;
      border-radius: 8px;
      min-height: 43px !important;
      margin: 0 !important;
      box-shadow: none !important;
    }
    .v-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #999999;
    }
  }
  &_questions {
    // padding-top: 16px;
    &__header {
      // line-height: 47px;
      color: #262626;
      font-weight: 600;
      font-size: 14px;
    }
    &__content {
      padding: 20px !important;
      .accordion {
        z-index: unset;
        padding: 0;
        &-header {
          display: flex;
          justify-content: space-between;
          color: #4b4b4b;
          min-height: 24px;
          font-weight: 500;
          font-size: 14px;
          padding-bottom: 6px;
        }
        .v-expansion-panel:last-of-type{
          margin-bottom: 0 !important;
          hr{
            display: none;
          }
        }
        .v-expansion-panel::before{
          content: '';
          display: none;
        }
        .v-expansion-panel::after{
          content: '';
          display: none;
        }
        &-content {
          color: #929292;
          font-weight: 400;
          font-size: 14px;
          .v-expansion-panel-content__wrap {
              padding:0;
          }
        }
        hr{
          margin-top: 6px;
        }
      }
    &__empty{
        padding: 12px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap:16px;
        .v-icon .v-icon__component{
          width: 48px;
          height: 48px;
        }
        p{
          color:#262626;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          margin-bottom:0;
        }
      }
    }
  }
  &_contacts {
    display: flex;
    border-radius: 8px;
    border: 1px solid #E0E1E4;
    background: #FFF;
    margin-top: 32px;
    padding: 20px;
    &__divider {
      margin-top: 12px !important;
      margin-right: 0;
      height: 107px;
    }
    &__network {
      padding-left: 0;
      align-items: center;
      color: #262626;
      font-size: 14px;
      font-weight: 600;
      line-height: 120%;
      width: 40%;
      border-right: 1px solid #E0E1E4;
      gap: 16px;
      display: flex;
      flex-direction: column;
      padding: 20px 16px 0 0;
      &-social{
        display: flex;
        gap: 24px;
        justify-content: center;
        &-icon{
          width: 40px !important;
          height: 40px !important;
          .v-icon__component{
            width: 40px !important;
            height: 40px !important;
          }
        }
      }
      &-info {
        width: 60%;
        display: flex;
        padding-left: 16px !important;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        li{
          list-style-type: none;
          a{
            display: flex;
            justify-content: center;
            gap: 10px;
            text-decoration: none;
          }
        }
        span {
          font-weight: 400;
          font-size: 14px;
          color: #929292;
          line-height: 18px;
        }
      }
    }
  }
}
.main-sidebar{
  .v-navigation-drawer__content, .v-navigation-drawer__append{
    .v-list-item__title{
      color: #262626;
      font-weight: 500;
    }
    .selected-menu-item-active .v-list-item__title {
      color: #06BDE9;
    }
  }
}
@media (max-width: $xsBreakpoint) {
  .support{
    padding: 16px;
  }
  .support_contacts__network{
    padding: 20px 12px 0 0;
    width: 50%;
    &-info{
      padding-left: 12px !important;
      span{
        font-size: 12px;
      }
    }
  }
}
</style>
